// pl_pms_billing.ts
// Tłumaczenia dla PMS.Billing.tsx

export const plPmsBilling = {

  title: "Rozliczenia",
  description: "Karty pobytowe, rozliczenia grupowe, zwroty, korekty i faktury.",

  // ── Sekcje ───────────────────────────────────────────────────────────────
  sections: {
    folioWorkspace: "Karty pobytowe",
    folioActivity: "Historia karty pobytowej",
    postCharges: "Księgowanie opłat",
    refundsAdjustments: "Zwroty i korekty",
    invoicesFiscal: "Faktury",
    groupBillingSnapshot: "Rozliczenia grupowe",
  },

  // ── Opisy sekcji ─────────────────────────────────────────────────────────
  descriptions: {
    chargeWorkflow: "Księgowanie opłat, rozliczenia kart pobytowych i wystawianie faktur.",
    currentItems: "Pozycje, płatności i zwroty dla wybranej karty pobytowej.",
    controlledReversal: "Proces cofnięcia i korekty operacji.",
    partialPayments: "Płatności częściowe z wykorzystaniem różnych metod płatności.",
    generateInvoice: "Generowanie faktur.",
    groupFolioSummary: "Podsumowanie kart grupowych.",
  },

  // ── Metody płatności ──────────────────────────────────────────────────────
  paymentMethods: {
    card: "Karta",
    cash: "Gotówka",
    noPayment: "Brak płatności",
    methodOne: "Metoda 1",
    methodTwo: "Metoda 2",
  },

  // ── Kategorie opłat ───────────────────────────────────────────────────────
  chargeCategories: {
    minibar: "Minibar",
    lateCharge: "Opłata za późne wymeldowanie",
    other: "Inne",
  },

  // ── Etykiety ──────────────────────────────────────────────────────────────
  labels: {
    folio: "Karta pobytowa",
    invoice: "Faktura",
    fiscalizedInvoice: "Faktura fiskalna",
    chargeCategory: "Rodzaj opłaty",
    balanceDue: "Kwota do zapłaty",
    activeFolio: "Aktywna karta pobytowa",
    billingCompany: "Dane firmy do faktury",
    noFolioSelected: "Nie wybrano karty pobytowej",
  },

  // ── Komunikaty ────────────────────────────────────────────────────────────
  messages: {
    adjustmentFailed: "Nie udało się wykonać korekty.",
    chargeFailed: "Nie udało się zaksięgować opłaty.",
    invoiceFailed: "Nie udało się wygenerować faktury.",
    refundFailed: "Nie udało się zrealizować zwrotu.",
  },

} as const;

export default plPmsBilling;